import type { SVGProps } from "react";
export const VerticalDotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    className="fill-current"
    {...props}
  >
    <path
      fill="#C6C6C6"
      d="M14.25 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2-4a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
  </svg>
);
